import { render } from "./App.vue?vue&type=template&id=1483ec44"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=1483ec44&lang=css"

import exportComponent from "C:\\Users\\Admin\\Documents\\LoesusPedagogia\\ArchiV2\\LP-MyFirstBusiness\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__